import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorSlice from "../../Services/errorSlice";
import userGroupService from "../../Services/userGroup.service";
import { alertSnackbarError, alertSnackbarSuccess } from "./alertStatusSlice";

const initialState = {
  loading: false,
  result: [],
};
export const userGroupList = createAsyncThunk(
  "userGroup/list",
  async (values, thunkAPI) => {
    try {
      const result = await userGroupService.list(values).then((respone) => {
        const { data } = respone;
        return data.result;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const userGroupCreate = createAsyncThunk(
  "userGroup/create",
  async (values, thunkAPI) => {
    try {
      const result = await userGroupService.create(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const userGroupUpdate = createAsyncThunk(
  "userGroup/update",
  async (values, thunkAPI) => {
    try {
      const result = await userGroupService.update(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const userGroupDelete = createAsyncThunk(
  "userGroup/delete",
  async (values, thunkAPI) => {
    try {
      const result = await userGroupService.destroy(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const userGroupSlice = createSlice({
  name: "userGroupSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userGroupList.pending, (state, action) => {
      state.loading = true;
      state.result = [];
    });
    builder.addCase(userGroupList.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(userGroupList.rejected, (state, action) => {
      state.loading = false;
      state.result = [];
    });
  },
});

export const { reducer } = userGroupSlice.actions;

export default userGroupSlice.reducer;
